import { Store } from 'src/store/index';

const hasDesignStructureChanged = (store: Store) => store.design.hasStructureChanged;

export default hasDesignStructureChanged;
